import './App.css';
import AppRoutes from './routes';
import './index.css';
import './styles/common.css';

function App() {
  return <AppRoutes/>
}

export default App;
